import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "演员资料", to: "/actors" },
  { label: "关于我们", to: "/about" },
];

const collections = [
  { label: "系列全解析", to: "/category" },
  { label: "经典系列", to: "/category?tag=经典系列" },
  { label: "最新上映", to: "/category?tag=最新上映" },
  { label: "高分推荐", to: "/category?sort=rating" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-secondary-100 md:mt-24">
      <div className="mx-auto grid w-full max-w-[1240px] gap-8 px-4 py-12 md:grid-cols-2 md:px-6 md:py-14 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-film-line text-lg" />
            </span>
            <span>
              <span className="block font-heading text-lg font-semibold text-foreground-950">蜜桃成熟时电影</span>
              <span className="block text-[10px] uppercase tracking-[0.24em] text-foreground-500">
                Peach Cinema Archive
              </span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            专注「蜜桃成熟时」系列电影的资料型网站，整理系列片目、剧情梗概、演职员资料与影视资讯，为影迷与研究者提供清晰、可靠的阅读入口。
          </p>
          <div className="mt-5 flex items-center gap-2">
            <a
              href="mailto:hello@peachcinema.example"
              aria-label="发送邮件"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-secondary-300 text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
            >
              <i className="ri-mail-line" />
            </a>
            <a
              href="https://911fuli2.asia"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="微博"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-secondary-300 text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
            >
              <i className="ri-weibo-line" />
            </a>
            <a
              href="https://www.douban.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="豆瓣"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-secondary-300 text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
            >
              <i className="ri-douban-line" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">网站导航</h4>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-foreground-700 transition-colors hover:text-accent-600"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.16em] text-foreground-500">内容合集</h4>
          <ul className="mt-4 space-y-2.5">
            {collections.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className="text-sm text-foreground-700 transition-colors hover:text-accent-600"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-200">
        <div className="mx-auto flex w-full max-w-[1240px] flex-col gap-2 px-4 py-5 text-[11px] leading-relaxed text-foreground-500 md:flex-row md:items-center md:justify-between md:px-6">
          <p>© 2026 蜜桃成熟时电影 · 本站为影视资料演示站点，内容均为模拟数据。</p>
          <p>不提供在线播放与下载 · 仅用于内容展示与学习交流</p>
        </div>
      </div>
    </footer>
  );
}